// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1Wh6E","title":"styles_title__yrPhp","actions":"styles_actions__3gPBw"};